import { StaticBaseDao } from '@/dao';
import { StringArray, PostResponse } from '@/objects/generated';

export class RaceContestantDetailsDao extends StaticBaseDao {
    public static async SaveContestantMemo(eventID: number, contestantID: number, memo: StringArray): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `RaceContestantDetails/SaveContestantMemo` +
                '?' +
                (eventID == undefined ? '' : `eventID=${eventID}`) +
                '&' +
                (contestantID == undefined ? '' : `contestantID=${contestantID}`),
            'POST',
            memo,
        );
    }
}
